import {Search, Sort} from "@mui/icons-material";
import {IconButton, Tooltip, Typography} from "@mui/material";
import {DataGridPro} from "@mui/x-data-grid-pro";
import React from "react";
import {withAppContext} from "../util/withAppContext";
import {Grey4} from "../theme/styles";
import css_enlil_table from "./Common/css/EnlilTable.module.scss";
import withBreakpoint from "../util/withBreakpoint";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import spinner from "../assets/Spinner-1s-200px.svg";
import {CustomGridTreeDataGroupingCell} from "./CustomGridTreeDataGroupingCell";
import {EnlilTable} from "./EnlilTable";
import {prepareBuffer} from "../util/Buffer";

export class EnlilTableTree extends EnlilTable {
    componentDidMount() {

        this.applet.getEnterpriseComponent().addLoadCompletedListener(this);
        this.applet.getEnterpriseComponent().addLoadStartedListener(this);
        this.applet.getEnterpriseComponent().addInvalidListener(this);
        this.applet.getEnterpriseComponent().addUpdateStartedListener(this);
        this.applet.getEnterpriseComponent().addUpdateCompletedListener(this);
        this.applet.getEnterpriseComponent().addDeleteCompletedListener(this);
        this.applet.getEnterpriseComponent().addInsertCompletedListener(this);
        this.applet.getEnterpriseComponent().addQueryRollbackCompletedListener(this);
        this.applet.getEnterpriseComponent().addSingleRecordRefreshStartedListener(this);
        this.applet.getEnterpriseComponent().addSingleRecordRefreshCompletedListener(this);

        this.searchEnterpriseComponent.addLoadStartedListener(this);
        this.searchEnterpriseComponent.addLoadCompletedListener(this);
        this.searchEnterpriseComponent.addInvalidListener(this);

        this.makeSortSpecification(null);

        if (this.state.action === "New") {
            this.applet.getEnterpriseComponent().newRecord();
        } else {
            this.applet.getEnterpriseComponent().setSortSpecification(this.getSortSpecification()?.Options);
            if (this.searchSpecification) this.applet.getEnterpriseComponent().setSearchSpecification(this.searchSpecification);
            this.applet.getEnterpriseComponent().setVisibilityMode(this.props.appContext.sessionContext.getActiveVisibility()?.Mode);
            this.applet.getEnterpriseComponent().setVisibilityValue(this.props.appContext.sessionContext.getActiveVisibility()?.Value);
            this.applet.getEnterpriseComponent().executeQuery(this.memoryState.pageToDisplay, this.memoryState.pageSize);
        }
    }

    enterpriseComponentLoadStarted(ec) {
        this.setState({fetchBackgroundOperation: true, previousBuffer: this.state.buffer});
    };

    enterpriseComponentLoadCompleted(ec) {
        if (ec.serialNumber === this.applet.getEnterpriseComponent().serialNumber) {
            this.memoryState.numberOfPages = Math.max(1, Math.ceil((this.applet.getEnterpriseComponent().getTotalRowcount() ?? 0) / this.memoryState.pageSize));
            this.memoryState.pageToDisplay = Math.min(this.memoryState.pageToDisplay, this.memoryState.numberOfPages);

            this.setState({buffer: prepareBuffer(ec), fetchBackgroundOperation: false, queryController: ec});
        }
        if (ec.serialNumber === this.searchEnterpriseComponent.serialNumber) {
            this.memoryState.numberOfPages = Math.max(1, Math.ceil((this.searchEnterpriseComponent.getTotalRowcount() ?? 0) / this.memoryState.pageSize));
            this.memoryState.pageToDisplay = Math.min(this.memoryState.pageToDisplay, this.memoryState.numberOfPages);

            this.applet.getEnterpriseComponent().resultsBuffer = this.searchEnterpriseComponent.resultsBuffer;
            this.applet.getEnterpriseComponent().totalRowcount = this.searchEnterpriseComponent.totalRowcount;
            this.applet.getEnterpriseComponent().setMode(EnterpriseComponent.MODE_RESULTS);
            this.applet.getEnterpriseComponent().setIsValid(true);

            this.applet.getEnterpriseComponent().invalidateChildren();

            let queryBuffer = this.searchEnterpriseComponent.queryBuffer;
            this.searchEnterpriseComponent.newQuery();
            this.searchEnterpriseComponent.queryBuffer = queryBuffer;
            this.applet.getEnterpriseComponent().setPagePointer(this.memoryState.pageToDisplay);
            this.setState({buffer: prepareBuffer(this.applet.getEnterpriseComponent()), fetchBackgroundOperation: false, queryController: ec});
        }
    };

    enterpriseComponentInsertCompleted(ec){
        ec.invalidate();
    };

    enterpriseComponentRecordChanged(ec){
        this.setState({buffer: prepareBuffer(ec)});
    };

    _getColumns = (breakpoint, loading) => {
        let columns = [];

        for (let columnIndex = 0; columnIndex < this.props.placement[breakpoint].length; columnIndex++) {
            let columnMetadata = this.props.columns.find((element) => element.id === this.props.placement[breakpoint][columnIndex].id);
            let headerRenderer = columnMetadata.headerRenderer;

            let sortable = false;
            if (this.getSortSpecification() !== null && this.getSortSpecification().Options !== undefined) {
                for (let i = 0; i < this.getSortSpecification().Options.length; i++) {
                    if (columnMetadata.id === this.getSortSpecification().Options[i].SortAttribute) {
                        sortable = true;
                    }
                }
            }
            let headerAlign = columnMetadata.headerAlign;
            if (headerAlign === undefined) {
                headerAlign = "Left"
            }
            let column = {
                field: columnMetadata.id,
                headerName: columnMetadata.headerTitle,
                editable: false,
                sortable: false,
                filterable: false,
                headerAlign: headerAlign,
                resizable: columnMetadata.resizable,
                pinnable: false,
                disableColumnMenu: true,
                hideable: columnMetadata.hideable
            };
            if (columnMetadata.flex !== undefined) {
                column["flex"] = columnMetadata.flex;
            } else if (columnMetadata.width !== undefined) {
                column["width"] = columnMetadata.width + (sortable ? 45 : 0);
            }
            if (loading) {
                if (this.state.previousBuffer.length === 0) {
                    column["renderCell"] = null;
                } else {
                    column["renderCell"] = (params) => this.getCellRenderer(columnMetadata.cellRenderer)(this, params, this.props.placement[breakpoint][columnIndex].id, breakpoint);
                }
            } else {
                if (this.state.buffer.length === 0) {
                    column["renderCell"] = null;
                } else {
                    column["renderCell"] = (params) => this.getCellRenderer(columnMetadata.cellRenderer)(this, params, this.props.placement[breakpoint][columnIndex].id, breakpoint);
                }
            }
            if (headerRenderer === null) {
                column["renderHeader"] = null;
            } else {
                column["renderHeader"] = (params) => this.getHeaderRenderer(columnMetadata.headerRenderer)(this, params, this.props.placement[breakpoint][columnIndex].id, breakpoint);
            }
            columns.push(column);
        }
        columns.push({
            field: "path",
            headerName: "",
            editable: false,
            sortable: false,
            filterable: false,
            headerAlign: "Left",
            resizable: false,
            pinnable: false,
            disableColumnMenu: false,
            hideable: false,
            renderCell: (params) => this.renderPathCell(this, params, "path", breakpoint)

        })
        return columns;
    };

    getRows = (breakpoint, columns) => {
        let rows = [];

        for (let i = 0; i < this.state.buffer.length; i++) {
            let row = {
                id: i,
            };
            row["RowSelected"] = i === this.getSelectedRecordNumber();
            for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
                if (columns[columnIndex].field !== "path") {
                    let columnMetadata = this.props.columns.find((element) => element.id === columns[columnIndex].field);

                    row[columnMetadata.id] = this.state.buffer[i].get(columnMetadata.id);
                } else {
                    row["path"] = this.state.buffer[i].get("path");
                }
            }
            rows.push(row);
        }
        return rows;
    };

    getTreeDataPath = (row) => {
        if (row.path === undefined) return [];

        return row.path.split('/');
    }

    render() {
        let loading = this.state.fetchBackgroundOperation === true;
        let columns = this.getColumns(this.props.breakpoint?.getBreakPointName(), false);
        let pinnedColumns = this.getPinnedColumns(this.props.breakpoint?.getBreakPointName());
        let rows = loading ? [] : this.getRows(this.props.breakpoint?.getBreakPointName(), columns);

        return (
            <>
                {this.renderExtension()}
                <div key={1} style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <div style={{display: "flex", flexDirection: "row", width: "100%", height: "30px", marginLeft: "auto", marginRight: "auto", justifyContent: "space-between"}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            {this.props.title !== null ? (
                                <div style={{fontSize: "14pt", fontWeight: "500", color: "#1498D8", margin: "-4px 0 0 0", overflow: "hidden"}}>
                                    <Typography style={{fontSize: 22, fontWeight: 500, color: "#1498D8"}}>{this.props.title}</Typography>
                                </div>
                            ): null}
                            {this.props.menu !== null ? (
                                <div style={{fontSize: "14pt", fontWeight: "500", color: "#1498D8", margin: "-3px 0 0 0", overflow: "hidden"}}>
                                    {this.renderMenu()}
                                </div>
                            ): null}
                        </div>
                        <div>
                            {loading ? (
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                    <div style={{margin: "-3px 0 0 0"}}>
                                        <img width="35" height="35" src={spinner} alt="spinner" />
                                    </div>
                                    <div className={css_enlil_table.BlinkingText} style={{margin: "4px 0 0 5px"}}>
                                         <Typography style={{fontSize: "14px", fontWeight: 400, color: Grey4}}>Loading...</Typography>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                            {this.props.sort && (this.props.enableSort === undefined || this.props.enableSort === true) ? (
                                <div style={{marginTop: "-9px"}}>
                                    <Tooltip title={"Sort"}>
                                        <IconButton disableRipple={true} onClick={(event) => {
                                            this.setState({sortMenuTarget: event.currentTarget});
                                            //this.setState({showSortSelection: true})
                                        }}>
                                            <Sort />
                                        </IconButton>
                                    </Tooltip>
                                    {this.renderSortSelector()}
                                </div>
                            ): null}
                            {(this.props.enableSearch === undefined || this.props.enableSearch === true) && this.props.simpleSearch ? (
                                <div style={{marginTop: "-9px"}}>
                                    <Tooltip title={"Search"}>
                                        <IconButton disableRipple={true}
                                            onClick={() => {
                                                if (this.state.showSearch) {
                                                    this.applet.getEnterpriseComponent().executeQueryRollback()
                                                    this.setState({showSearch: false});
                                                } else {
                                                    //this.applet.getEnterpriseComponent().setMode(EnterpriseComponent.MODE_QUERY);
                                                    this.setState({showSearch: true});
                                                }
                                            }}>
                                            <Search />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {this.state.showSearch && this.props.simpleSearch ? (
                        this.renderSearch()
                    ) : null}
                    <div style={{width: "100%"}}>
                        <DataGridPro treeData
                                     getTreeDataPath={this.getTreeDataPath}
                                     groupingColDef={{
                                         headerName: this.props.columns.find((element) => element.id === "Leader").headerTitle,
                                         width: this.props.columns.find((element) => element.id === "Leader").width,
                                         hideDescendantCount: true,
                                         renderHeader: (params) => this.renderStandardSingleHeader(null, params, null, null),
                                         renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} offsetMultiplier={2}/>
                                     }}
                                     style={{border: "1px solid #D8DDE4", fontSize: "14px", borderRadius: this.state.showSearch ? "0 0 5px 5px" : "5px 5px 5px 5px"}}
                                     columns={columns}
                                     defaultGroupingExpansionDepth={this.props.expansionDepth !== undefined ? this.props.expansionDepth : 1}
                                     pinnedColumns={pinnedColumns}
                                     rows={rows}
                                     fullWidth={true}
                                     density="compact"
                                     filterMode="client"
                                     hideFooter={true}
                                     hideFooterRowCount={true}
                                     hideFooterPagination={true}
                                     hideFooterSelectedRowCount={true}
                                     onRowDoubleClick={(params) => this.onRowDoubleClick(params)}
                                     onRowClick={(params) => this.onRowClick(params)}
                                     loading={loading}
                                     {...(this.props.rowHeight ? {rowHeight: this.props.rowHeight} : {})}
                            sx={{
                                '.MuiDataGrid-columnHeaderTitleContainer': {
                                    display: "inline",
                                }
                            }}/>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", width: "100%", height: "30px", paddingTop: "3px", marginLeft: "auto", marginRight: "auto", justifyContent: "flex-start", background: "#FFFFFF",}}>
                        {this.applet.getEnterpriseComponent().getMode() !== EnterpriseComponent.MODE_QUERY ? this.renderPagination() : null}
                    </div>
                </div>
            </>
        );
    }
}

export default withBreakpoint(withAppContext(EnlilTableTree));